import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'disputes',
  inputShow: gql`
    query disputes($input: DisputeQueryInput) {
      disputes(input: $input) {
        id
      }
    }
  `,
  create: Create,
  edit: Edit,
  list: List,
  show: Show,
  options: {
    group: 'Billing',
    label: 'Disputes',
  },
};
